var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center"},[_c('h1',[_vm._v("Denna sida verkar ej finnas🤔")]),_c('v-btn',{attrs:{"to":"/dashboard","color":"primary"}},[_vm._v("Jag är vilse, ta mig hem")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }